if(document.querySelector('.print-order')) {
  window.print()
}